<template>
  <div class="w-full h-full m-auto flex justify-center items-center">
    <div class="w-56 h-56 relative flex justify-center items-center">
      <div class="absolute w-full h-full rounded-full border-solid border-t-2 border-r-2 text-gray-light border-color-spin animate-spin-slow">
        <div class="absolute h-1 w-1/2 top-1/2 left-1/2 bg-blue-100 transform -rotate-45 origin-left a-circle"></div>
      </div>
      <div class="absolute w-3/4 h-3/4 rounded-full border-solid border-t-2 border-l-2 text-blue-light border-color-spin1 animation-reverse animate-spin-slow">
        <div class="absolute h-1 w-1/2 top-1/2 left-1/2 bg-blue-100 transform -rotate-135 origin-left a-circle"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Spinner",
}
</script>

<style lang="scss" scoped>
  .border-color-spin {
    border-color: currentColor transparent transparent currentColor;
  }

  .border-color-spin1 {
    border-color: currentColor currentColor transparent transparent;
  }

  .animation-reverse {
    animation-direction: reverse;
  }

  .a-circle {
    &::after{ 
      position: absolute;
      top: -0.5em;
      right: -0.5em;
      content: '';
      width: 1em;
      height: 1em;
      background-color: currentColor;
      border-radius: 50%;
      box-shadow: 0 0 2em, 0 0 4em, 0 0 6em, 0 0 8em, 0 0 10em, 0 0 0 0.5em rgba(255, 255, 0, 0.1);
    }
  }
</style>
